module.exports = __webpack_public_path__ + "img/logo-name.12579160.png";